import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum FeatureOnboardingType {
  PACKAGE_PROTECTION_PLUS = "package_protection_plus",
  EXPANDED_WARRANTY = "extended_warranty",
  CONVERSION = "conversion",
  MANAGED_RETURNS = "managed_returns",
  INTERCOM_MOVED = "intercom_moved",
  DISABLED = "disabled",
  SUPPORT_TO_AI_UPSELL = "support_to_ai_upsell",
  COMMENTSOLD_REDO = "commentsold_redo",
  SHOPPER_AI_WRAPPED = "shopper_ai_wrapped",
  HELP_ICON_MOVING = "help_icon_moving",
  AGENTIC_CATALOG = "agentic_catalog",
  BILLING_SETTINGS_CONSOLIDATED = "billing_settings_consolidated",
  OUTBOUND_LABELS_UPSELL_UPS = "outbound_labels_upsell_ups",
  OUTBOUND_LABELS_UPSELL_AMAZON = "outbound_labels_upsell_amazon",
  OUTBOUND_LABELS_UPSELL_DHL = "outbound_labels_upsell_dhl",
  DISPUTES_WELCOME = "disputes_welcome",
  CROSS_BORDER_ONBOARDING = "cross_border_onboarding",
  SHIPPING_CLAIMS_AUTO_FILING = "shipping_claims_auto_filing",
  RECLAIM_ANNOUNCEMENT = "reclaim_announcement",
  HOMEPAGE_ANALYTICS_MOVED = "homepage_analytics_moved",
  NAV_REORGANIZATION = "nav_reorganization",
  // Historical onboarding types (no longer actively used but exist in MongoDB data)
  OUTBOUND_VIEWS_MOVED = "outbound_views_moved",
  AI_EXCHANGE_AGENT_UPSELL = "ai_exchange_agent_upsell",
  INTERNATIONAL_RETURNS = "international_returns",
  ROLES_PERMISSIONS_UPDATE = "roles_permissions_update",
  MARKETING_TEXAS_SMS_PROTECTION = "marketing_texas_sms_protection",
  BLACK_FRIDAY_TIPS = "black_friday_tips",
  PERMISSIONS_ROLES = "permissions_roles",
  OUTBOUND_LABELS = "outbound_labels",
}

export const FeatureOnboardingConfigSchema = z.object({
  dismissals: z.number(),
  lastDismissal: z.iso.datetime().nullish(),
  completed: z.boolean().optional(),
});

export const UserOnboardingSchema = z.object({
  _id: zExt.objectId(),
  userId: zExt.objectId(),
  type: createEnum(FeatureOnboardingType, {
    enumName: "FeatureOnboardingType",
  }),
  viewHistory: FeatureOnboardingConfigSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const UpsertUserOnboardingSchema = z.object({
  userId: zExt.objectId(),
  type: createEnum(FeatureOnboardingType, {
    enumName: "FeatureOnboardingType",
  }),
  viewHistory: FeatureOnboardingConfigSchema,
});

export type UserOnboarding = z.infer<typeof UserOnboardingSchema>;
export type UpsertUserOnboarding = z.infer<typeof UpsertUserOnboardingSchema>;
export type FeatureOnboardingConfig = z.infer<
  typeof FeatureOnboardingConfigSchema
>;
